// extracted by mini-css-extract-plugin
export var page = "pageWelcome-module--page--Lz3rG";
export var container = "pageWelcome-module--container--emKWe";
export var tag = "pageWelcome-module--tag--Oa5W+";
export var he = "pageWelcome-module--he--2j-AR";
export var circle = "pageWelcome-module--circle--kXQBj";